import { generateItems } from 'domain/common';
import { SmcTag } from 'domain/lib';
import { field } from 'cpcs-reconnect';

const { actions, selectors, reducer } = generateItems('SmcTag', SmcTag);

export { actions, selectors, reducer };
export const smctag = field('smctag');
